import React from 'react'
import ReactPlayer from 'react-player'
import styled from 'styled-components'

import { Heading2, Paragraph } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Row = styled.div`
  margin-top: 48px;
  @media (min-width: ${(p) => p.theme.breakpointLg}) {
    display: flex;
    column-gap: 16px;
    justify-content: space-between;
  }
`

const VideoWrapper = styled.div`
  width: 100%;
  margin-bottom: 32px;
  p {
    margin-top: 16px;
  }
  @media (min-width: ${(p) => p.theme.breakpointLg}) {
    margin-bottom: 0px;
  }
`

const VideoInner = styled.div`
  padding-top: calc(9 / 16 * 100%);
  position: relative;
  > div {
    position: absolute !important;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    width: 100% !important;
    height: auto !important;
  }
`

const VideoAndText = () => {
  return (
    <>
      <Heading>Video and text</Heading>
      <VideoWrapper>
        <VideoInner>
          <ReactPlayer controls url="https://www.youtube.com/watch?v=PbgcZv16vlY" width="100%" height="100%" />
        </VideoInner>
        <Paragraph>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          aliqua.
        </Paragraph>
      </VideoWrapper>
      <Row>
        <VideoWrapper>
          <VideoInner>
            <ReactPlayer controls url="https://www.youtube.com/watch?v=PbgcZv16vlY" width="100%" height="100%" />
          </VideoInner>
          <Paragraph>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore aliqua.
          </Paragraph>
        </VideoWrapper>
        <VideoWrapper>
          <VideoInner>
            <ReactPlayer controls url="https://www.youtube.com/watch?v=PbgcZv16vlY" width="100%" height="100%" />
          </VideoInner>
          <Paragraph>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore aliqua.
          </Paragraph>
        </VideoWrapper>
      </Row>
    </>
  )
}

export default VideoAndText
